import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function DeleteConfirmationModal({
  show,
  onClose,
  onConfirm,
  pagina,
  name,
  modificacoes,
  warming,
}) {
  const [inputValue, setInputValue] = useState("");
  const { t } = useTranslation();

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  useEffect(() => {
    if (!show) {
      setInputValue("");
    }
  }, [show]);
  return (
    <Modal backdrop="static" centered size="md" show={show} onHide={onClose}>
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>
          {t("button_delete")} {t(pagina)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {name ? (
          <>
            <p>
              {t("confirm_delete")} {pagina} {name}
              {t("question_mark")}
            </p>
            {modificacoes && (
              <p>
                {t("deleting_will_remove")} {pagina}
                {t("will_delete")} <strong>{t("all")}</strong> {t("the")}{" "}
                {modificacoes} {t("of_this")} {pagina} {t("full_stop")}
              </p>
            )}
            <Form.Group controlId="formConfirmationInput" className="mt-3">
              <Form.Label>
                {t("Digite")} {name} {t("to_confirm")}
              </Form.Label>
              <Form.Control
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                placeholder={`Digite "${name}"`}
              />
            </Form.Group>
          </>
        ) : (
          <>
            <p>
              {t("confirm_deletion")}{" "}
              {pagina === "grupo de mapeamento"
                ? t("grupo de mapeamento e todos os mapeamentos dentro dele")
                : t(pagina)}
              {t("question_mark")}
            </p>
            {warming && <p className="">{warming}</p>}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="danger"
          onClick={onConfirm}
          disabled={name ? inputValue !== name : false}
        >
          {t("button_delete")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
DeleteConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  pagina: PropTypes.string,
  modificacoes: PropTypes.string,
  name: PropTypes.string,
  warming: PropTypes.string,
};
export default DeleteConfirmationModal;
